// Form1.js
import React, { useState, useRef } from 'react';
import ChatBox from '../../custom_elements/ChatBox';
import { CustomInput, validationRules } from '../../custom_elements/CustomInput';
import CustomSelect from '../../custom_elements/CustomSelect';

export default function Form6({ nextForm, passGetFormData, passValidateAllFormFields, retrievedFormData = {}, sendChat}) {
    const formRefs = useRef([]);  // Reference array to store refs of CustomInput fields

    const [showPersUe, setShowPersUe] = useState(true);
    const [showPers, setShowPers] = useState(false);
    const [showFin, setShowFin] = useState(false);

    const getFormData = () => {
        console.log("INSIDE GETFORMDATA on Form6");
        const form = document.getElementById('Form6');
        const formData = new FormData(form);
        const data = {};
        for (let [key, value] of formData.entries()) {
            data[key] = value;
        }
        return {person: [data], kommentar: formData.get('kommentar')};
    };

    React.useEffect(() => {
        console.log('Form6 mounted');
        passGetFormData(() => getFormData); // Pass the getFormData function to the parent
    }, [passGetFormData]);



    const validateAllFormFields = () => {
      console.log("validateAllFormFields in Form6");
      let isValid = true;
console.log(formRefs);
      // Ensure refs are properly populated
      if (formRefs.current.length === 0) {
        console.error("No form refs found!");
        return false;
      }

      // Loop through all form inputs and call validateField on each one
      formRefs.current.forEach(inputRef => {
        if(inputRef != null) {
          console.log("checking ref: ", inputRef);
          // Check if inputRef is defined and properly set
          if (inputRef?.validateField()) {
            console.log("Field is valid:", inputRef?.validateField());
          } else {
            console.warn("Ref is not initialized or validateField failed:", inputRef);
            isValid = false; // Optional: Fail validation if ref is not set or invalid
          }
        }
      });

      return isValid;
    };

    React.useEffect(() => {
        console.log("INSIDE useEffect passValidateAllFormFields on Form6");

        passValidateAllFormFields(() => validateAllFormFields);
    }, [passValidateAllFormFields]);



    const togglePersUeVisibility = () => {
        if (!showPersUe) {
            setShowFin(false);
            setShowPers(false);
        }
        setShowPersUe(prevState => !prevState);
    };

    const togglePersVisibility = () => {
        if (!showPers) {
            setShowFin(false);
            setShowPersUe(false);
        }
        setShowPers(prevState => !prevState);
    };
    const toggleFinVisibility = () => {
        if (!showFin) {
            setShowPers(false);
            setShowPersUe(false);
        }
        setShowFin(prevState => !prevState);
    };

    return (
        <div className="formFieldBox">
            <form id="Form6">
                <a onClick={togglePersUeVisibility} className="toggleButton">
                    KONTAKTDATEN
                </a>
                <input type="hidden" name="pers_no" value="1" />
                <div className={showPersUe ? "formFieldContent visible-content" : "hidden-content formFieldContent"}>
                    <div className="fieldDiv">
                        <CustomSelect ref={el => formRefs.current[10] = el} formData={retrievedFormData} name="p_anrede" label="Anrede*" rules={[{ruleKey: "required"}]}>
                            <option value="1">Frau</option>
                            <option value="2">Herr</option>
                            <option value="3">Divers</option>
                        </CustomSelect>
                        <CustomInput ref={el => formRefs.current[1] = el} formData={retrievedFormData} name="p_titel" label="Titel" rules={[{ ruleKey: "maxLength", ruleParam: 16 }]} />
                    </div>
                    <div className="fieldDiv">
                        <CustomInput ref={el => formRefs.current[2] = el} formData={retrievedFormData} name="p_vorname" label="Vorname*" rules={[{ ruleKey: "maxLength", ruleParam: 16 }, { ruleKey: "required" }]} />
                        <CustomInput ref={el => formRefs.current[3] = el} formData={retrievedFormData} name="p_name" label="Nachname*" rules={[{ ruleKey: "maxLength", ruleParam: 16 }, { ruleKey: "required" }]} />
                    </div>
                    <div className="fieldDiv">
                        <CustomInput ref={el => formRefs.current[4] = el} formData={retrievedFormData} name="gebdat" label="Geburtsdatum*" type="date" rules={[{ ruleKey: "date" }, { ruleKey: "required" }]} />
                        <CustomInput ref={el => formRefs.current[5] = el} formData={retrievedFormData} name="p_adresse" label="Straße und Nr.*" rules={[{ ruleKey: "maxLength", ruleParam: 16 }, { ruleKey: "required" }]} />
                    </div>

                    <div className="fieldDiv">
                        <CustomInput ref={el => formRefs.current[6] = el} formData={retrievedFormData} name="p_plz" label="PLZ*" rules={[{ ruleKey: "plz" }, { ruleKey: "required" }]} />
                        <CustomInput ref={el => formRefs.current[7] = el} formData={retrievedFormData} name="p_ort" label="Ort*" rules={[{ ruleKey: "maxLength", ruleParam: 16 }, { ruleKey: "required" }]} />
                    </div>

                    <div className="fieldDiv">
                        <CustomInput ref={el => formRefs.current[8] = el} formData={retrievedFormData} name="p_mobil" label="Telefonnummer*" rules={[{ ruleKey: "phoneNumber" }, { ruleKey: "required" }]} />
                        <CustomInput ref={el => formRefs.current[9] = el} formData={retrievedFormData} name="p_email" label="Email*" rules={[{ ruleKey: "email" }, { ruleKey: "required" }]} />
                    </div>

                    <div className="fieldDiv">
                        <div className="inputField">
                            <div className="form-floating">
                                <textarea  style={{minHeight: "150px"}} className="form-control" name="kommentar" id="kommentar" label="Zusätzliche Informationen" rules={[{ ruleKey: "maxLength", ruleParam: 250}]} />
                                <label htmlFor="kommentar">Zusätzliche Informationen</label>
                            </div>
                        </div>
                    </div>

                    <div className="fieldDiv">
                        <div className="inputField">
                            <div className="form-floating">
                                <textarea  style={{minHeight: "150px"}} className="form-control" name="feedback" id="feedback" label="Feedback" rules={[{ ruleKey: "maxLength", ruleParam: 250}]} />
                                <label htmlFor="feedback">Feedback zu dieser Website</label>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}
